import React from 'react';
import ThemeProvider from '@components/theme/ThemeProvider';
import ErrorPage from '../components/pages/Error/Error';

const NotFound = () => (
  <ThemeProvider>
    <ErrorPage statusCode={404} />
  </ThemeProvider>
);
export default NotFound;
